import { forwardRef, useCallback, useEffect, useState } from "react";
import cn from "classnames";
import styles from "./TableGroups.module.sass";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SureModal from "../SureModal/SureModal";

interface TableGroupsProps {
	data: any[];
	onClickModelFormed: (id: number, objectName: string, row: any) => void;
	showSureModal: () => void;
	sureModalVisible: boolean;
	close: () => void;
	lastTargetRef: any;
}

const TableGroups = forwardRef<HTMLDivElement | null, TableGroupsProps>(
	({ data, onClickModelFormed, sureModalVisible, showSureModal, close, lastTargetRef }, ref) => {
		const navigate = useNavigate();
		const location = useLocation();
		const [selected, setSelected] = useState<any>();

		const { organizationId } = useParams();

		const [modelFormed, setModelFormed] = useState<any>([]);
		const [categoryAssigned, setCategoryAssigned] = useState<any>([]);
		const [waitingForModel, setWaitingForModel] = useState<any>([]);
		const [repeat, setRepeat] = useState<any>([]);

		useEffect(() => {
			setModelFormed([]);
			setCategoryAssigned([]);
			setWaitingForModel([]);
			setRepeat([]);

			data.forEach((item) => {
				if (item.repeatable) {
					setRepeat((prevState: any) => [...prevState, item]);
				} else if (item.categoryAssigned || (item.categoryAssigned && item.threatModelObjectExists)) {
					setWaitingForModel((prevState: any) => [...prevState, item]);
				} else if (item.threatModelObjectExists) {
					setModelFormed((prevState: any) => [...prevState, item]);
				} else {
					setCategoryAssigned((prevState: any) => [...prevState, item]);
				}
			});
		}, [data]);

		const className = useCallback(
			(id: number) => {
				return id === location.state?.outline ? styles.outline : "";
			},
			[location.state],
		);

		return (
			<div ref={ref} data-comment-false={true} className={styles.table}>
				{modelFormed.length ? (
					<div className={styles.state}>
						<div className={styles.titleState}>Модель угроз сформирована</div>
						<div className={styles.items}>
							{modelFormed.map((item: any) => (
								<div
									className={cn(styles.item, styles.blue, className(item.id))}
									key={item.id}
									onClick={() => onClickModelFormed(item.id, item.objectName, item)}>
									<div className={styles.titleItem}>{item.code}</div>
									<div className={styles.textItem}>{item.objectName}</div>
								</div>
							))}
						</div>
					</div>
				) : null}

				{waitingForModel.length ? (
					<div className={styles.state}>
						<div className={styles.titleState}>Категория присвоена</div>
						<div className={styles.items}>
							{waitingForModel.map((item: any) => (
								<div
									className={cn(styles.item, styles.green, className(item.id))}
									key={item.id}
									onClick={() => {
										navigate(`/categorization/finish/${organizationId}/${item.id}`, {
											state: {
												actId: item.topLevelKiiObjActDocId,
												resId: item.topLevelKiiObjResultDocId,
											},
										});
									}}>
									<div className={styles.titleItem}>{item.code}</div>
									<div className={styles.textItem}>{item.objectName}</div>
								</div>
							))}
						</div>
					</div>
				) : null}

				{categoryAssigned.length ? (
					<div className={styles.state}>
						<div className={styles.titleState}>Ожидает формирования модели угроз</div>
						<div className={styles.items}>
							{categoryAssigned.map((item: any) => (
								<div
									className={cn(styles.item, styles.white, className(item.id))}
									key={item.id}
									onClick={() => onClickModelFormed(item.id, item.objectName, item)}>
									<div className={styles.titleItem}>{item.code}</div>
									<div className={styles.textItem}>{item.objectName}</div>
								</div>
							))}
						</div>
					</div>
				) : null}

				{repeat.length ? (
					<div className={styles.state}>
						<div className={styles.titleState}>Повторное категорирование</div>
						<div className={styles.items}>
							{repeat.map((item: any) => (
								<div
									className={cn(styles.item, styles.purple, className(item.id))}
									key={item.id}
									onClick={() => {
										showSureModal();
										setSelected(item);
									}}>
									<div className={styles.titleItem}>{item.code}</div>
									<div className={styles.textItem}>{item.objectName}</div>
								</div>
							))}
						</div>
					</div>
				) : null}

				{sureModalVisible && (
					<SureModal close={close} callback={() => onClickModelFormed(selected.id, selected.objectName, selected)} />
				)}

				<div ref={lastTargetRef} />
			</div>
		);
	},
);

export default TableGroups;
